module.exports = __webpack_public_path__ + "images/skb-bank1-50a62930.png";